import "./Post.css"
import Avatar from '@material-ui/core/Avatar';
import React, { useState, useEffect } from 'react'
import { db } from './firebase.js';
import { Input } from '@material-ui/core';
import  Button  from '@material-ui/core/Button';
import firebase from "firebase"
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';





function Post( {postId, user, username, caption, imageURL} ) {

    
const [comments, setComments] = useState([]);
const [comment, setComment] = useState([]);

// edit post pop up
const [anchorEl, setAnchorEl] = React.useState(null);



      // import comments to state
        useEffect(() => {
            let unsubscribe;
            if (postId) {
                unsubscribe = 
                db.collection("posts").doc(postId).collection('Comments')
                //.orderBy("timestamp", 'desc' )
                .onSnapshot((snapshot) => {
                    setComments(snapshot.docs.map((doc) => doc.data()));
                    console.log(comments)
                });
            }
            return () => {
                unsubscribe();
            }
        }, [postId]);

    // upload comments to DB
       const postComment = (event) => {
            event.preventDefault();

            db.collection("posts").doc(postId).collection('Comments')
            .add({
                text: comment,
                username : user.displayName,
                timestamp: firebase.firestore.FieldValue.serverTimestamp()
            })
            setComment('');
       }
        // delete post
        const deletePost = () => {

            db.collection("posts").doc(postId).delete()
          
       }
       // Edit Menu ( DOTS )

            const handleClick = (event) => {
                setAnchorEl(event.currentTarget);
            };
            
            const handleClose = () => {
                setAnchorEl(null);
            };
 
    return (
        <div className="post">

            <div className="post__header">
                <div className='post__header_user'>
                    <Avatar className="post__avatar" alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
                    <h3>{username}</h3>
                </div>
            {/* edit the post */}      

                    {user?.displayName === username ? (

                        <div>
                            <IconButton children={MoreVertIcon} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                            <MoreVertIcon />
                            </IconButton>
                             <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={deletePost}>Delete Post</MenuItem>
                                </Menu>
                        </div>

                        ):(

                        <h3></h3>
                        )
                    }

                

            </div>

            <img className="post__image" src={imageURL}/>
            <h4 className="post__text"><strong>{username}</strong> {caption}</h4>

           {/*map over comments from state*/}
            
            <div className='post__comments'>
                {
                    comments.map((comment) => (
                        <p><strong>{comment.username}</strong> {comment.text}</p>
                    ))
                }
            </div>

            {/*Add comment Form*/}


            { user && (

                <form className='post__commentBox'>
                <Input 
                className='post__input'
                placeholder="  Add a comment..."
                type="text" 
                value={comment} 
                onChange={(e) => setComment(e.target.value)}
                />
                <Button 
                className='post__button'
                type="submit" 
                onClick={postComment}>Post</Button>

                </form>
            )}
                
            
         
         
        </div>
    )
}

export default Post
